import React from 'react';
import PropTypes from 'prop-types';
import * as supportedEvents from '../../util/supportedEvents';
import { stopPropagation } from '../../util/events';

export default class StopPropagation extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
    style: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  };

  render() {
    const { className, children, style } = this.props;

    return (
      <div
        style={style}
        className={className}
        onClick={stopPropagation}
        onMouseUp={supportedEvents.MOUSE_SUPPORT ? stopPropagation : null}
        onPointerUp={supportedEvents.POINTER_SUPPORT ? stopPropagation : null}
        onTouchEnd={supportedEvents.TOUCH_SUPPORT ? stopPropagation : null}
        onMouseDown={supportedEvents.MOUSE_SUPPORT ? stopPropagation : null}
        onPointerDown={supportedEvents.POINTER_SUPPORT ? stopPropagation : null}
        onTouchStart={supportedEvents.TOUCH_SUPPORT ? stopPropagation : null}
      >
        {children}
      </div>
    );
  }
}
